export function copyFromElm(text: string, elm: HTMLElement) {
    if (!elm) {
        return;
    }

    try {
        elm.innerText = text;

        const range = document.createRange();
        range.selectNodeContents(elm);

        const sel = window.getSelection();
        if (sel) {
            sel.removeAllRanges();
            sel.addRange(range);

            document.execCommand("copy");
        }
    } catch (e) {
        console.warn("copyFromElm");
        console.warn(e);
    }
}
